import { DayOfWeekType } from 'lib/daysOfWeek'
import { StoreCalendarType } from 'types/storeCalendar'
import { BusinessTimeType, OpenTimeType, StoreType } from 'types/store'
import { CollectiveStocksType } from 'types/confirm'
import { StoreGeoSearch } from 'types/storeGeoSearch'

export const SAVE_COLLECTIVE_STOCKS_CONFIRM = 'SAVE_COLLECTIVE_STOCKS_CONFIRM'
export const saveCollectiveStocksConfirmAction = (collectiveStocks: CollectiveStocksType) => {
  return {
    type: 'SAVE_COLLECTIVE_STOCKS_CONFIRM',
    payload: collectiveStocks,
  }
}

export const SAVE_CALENDAR_CONFIRM = 'SAVE_CALENDAR_CONFIRM'
export const saveCalendarConfirmAction = (
  holidays: DayOfWeekType[],
  open_time: OpenTimeType,
  order_start_time: BusinessTimeType,
  last_order_time: BusinessTimeType,
  last_pickup_time: BusinessTimeType,
  relative_pickupable_time: BusinessTimeType
) => {
  return {
    type: 'SAVE_CALENDAR_CONFIRM',
    payload: {
      holidays,
      open_time,
      order_start_time,
      last_order_time,
      last_pickup_time,
      relative_pickupable_time,
    },
  }
}

export const SAVE_STORE_CONFIRM = 'SAVE_STORE_CONFIRM'
export const saveStoreConfirmAction = (store: StoreType) => {
  return {
    type: 'SAVE_STORE_CONFIRM',
    payload: {
      store,
    },
  }
}

export const SAVE_STORE_GEO_SEARCH_CONFIRM = 'SAVE_STORE_GEO_SEARCH_CONFIRM'
export const saveStoreGeoSearchConfirmAction = (storeGeoSearch: StoreGeoSearch | undefined) => {
  return {
    type: 'SAVE_STORE_GEO_SEARCH_CONFIRM',
    payload: {
      storeGeoSearch,
    },
  }
}

export const SAVE_STORE_CALENDARS_CONFIRM = 'SAVE_STORE_CALENDARS_CONFIRM'
export const saveStoreCalendarsConfirmAction = (store_calendars: StoreCalendarType[]) => {
  return {
    type: 'SAVE_STORE_CALENDARS_CONFIRM',
    payload: {
      store_calendars,
    },
  }
}

export const UPDATE_EDIT_STATE = 'UPDATE_EDIT_STATE'
export const updateEditStateAction = (isBeingEdited: boolean) => {
  return {
    type: 'UPDATE_EDIT_STATE',
    payload: isBeingEdited,
  }
}

export const INIT_CONFIRM = 'INIT_CONFIRM'
export const initConfirmAction = () => {
  return {
    type: 'INIT_CONFIRM',
    payload: null,
  }
}
